import React, { ReactNode } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import pt from './messages/pt.json';
import en from './messages/en.json';
import es from './messages/es.json';
import { useAppSelector } from '@src/core/hooks';
import { messagesSelector } from '@src/features/i18nMessages';

export type Translate = {
  i18n: (messageId: DefaultMessagesKeys | undefined, query?: Record<string, string>) => string;
  i18nElement: (messageId: DefaultMessagesKeys | undefined, query?: Record<string, string>) => ReactNode;
};

export const useTranslate = (): Translate => {
  const intl = useIntl();
  const messages = useAppSelector(messagesSelector);
  const i18nElement = (messageId: DefaultMessagesKeys | undefined, query = {}) =>
    messages ? <FormattedMessage id={messageId} values={{ ...query, ...tagInterpreters }} /> : '';
  const i18n = (messageId: DefaultMessagesKeys | undefined, query = {}) =>
    messages ? intl.formatMessage({ id: messageId }, { ...query }).toString() : '';

  return { i18n, i18nElement };
};

const span = ((text: string) => <span>{text}</span>) as any as ReactNode;
const strong = ((text: string) => <strong>{text}</strong>) as any as ReactNode;
const br = (() => <br></br>) as any as ReactNode;
const tagInterpreters = {
  span,
  strong,
  br,
};

type ptKeys = keyof typeof pt;
type enKeys = keyof typeof en;
type esKeys = keyof typeof es;
export type DefaultMessagesKeys = ptKeys & enKeys & esKeys;

export default useTranslate;
